/*
 * @Author: randy
 * @Date: 2020-07-31 13:57:08
 * @LastEditTime: 2020-09-10 10:39:19
 * @Description: getters
 */
import { USER } from "@/store/types";
import { getStorageItem } from "@/utils/storage";

const getters = {
  token: state => state.user.token,
  user: state => {
    if (state.user.user) {
      return state.user.user;
    } else {
      return getStorageItem(USER);
    }
  },
  base: state => state.user.base,
  permissions: state => state.user.permissions,
  primaryColor: state => state.app.primaryColor,
  isCollapsed: state => state.app.isCollapsed,
  isMobile: state => state.app.isMobile,
  isPad: state => state.app.isPad,
  showDrawer: state => state.app.showDrawer,
  historyTags: state => state.app.historyTags,
  formSize: state => state.app.formSize,
  isPlaying: state => state.app.isPlaying,
  routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  defaultRoutePath: state => state.permission.defaultRoutePath
};

export default getters;
